import React from 'react';
import { Form, Select } from 'antd';

import {FontFamilyList} from './FontFamilyList';

const FontSelector = (props) => {

    const { Option } = Select;
    
    return (
        <Form.Item
            name="font"
            label="Font"
            rules={[
                {
                    required: true,
                    message: 'Font is required',
                },
            ]}
        >
            <Select
                showSearch
                style={{ width: 200 }}
                placeholder="Select a font"
                optionFilterProp="children"
                filterOption={(input, option) =>
                    option.props.children.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                className="light-darkable custom_font_select"
            >
                {FontFamilyList.map((font, index) => (
                    <Option key={`font-family-${index}`} value={font.name}>
                        <p style={{fontFamily: font.name}}>{font.nickname}</p>
                    </Option>
                ))}
            </Select>
        </Form.Item>
    );
}

export default FontSelector;